import React from 'react'
import type { Icon } from 'shared/utils'

const SmallSnacks = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'snacks',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            fill={color}
            {...otherProps}>
            <path
                d="M.13 5.875a.475.475 0 00-.13.354L.979 23.36a.476.476 0 00.475.449h13.254c.252 0 .46-.197.475-.449l.977-17.132a.475.475 0 00-.475-.504h-.237L16.126.91a.476.476 0 00-.406-.538L13.222.024a.473.473 0 00-.537.405l-.747 5.296h-.38l.456-3.246a.476.476 0 00-.405-.538l-2.503-.353a.477.477 0 00-.538.405l-.395 2.81-.653-2.596a.476.476 0 00-.578-.346l-2.448.616a.476.476 0 00-.346.578l1.055 4.187c-.021-.016-.048-.03-.068-.046L3.413.36a.478.478 0 00-.578-.346L.387.63a.477.477 0 00-.345.578l1.136 4.517H.476a.475.475 0 00-.346.15zm1.773 16.983l-.397-6.962h2.74c.309 1.354 1.908 2.39 3.834 2.39 1.926 0 3.525-1.036 3.835-2.39h2.74l-.398 6.962H1.903zm3.237-7.439c0-1.037 1.346-1.913 2.94-1.913 1.594 0 2.94.876 2.94 1.913 0 1.038-1.346 1.914-2.94 1.914-1.594 0-2.94-.876-2.94-1.914zm8.422-14.386l1.554.216-.63 4.476H12.9l.662-4.692zM9.445 2.598l1.56.22-.61 4.336c-.4.333-.998.584-1.69.71l.74-5.266zm-4.257.686l1.525-.383L7.82 7.308l-.091.651c-.507 0-.984-.077-1.414-.2L5.188 3.284zM1.082 1.437l1.524-.383 1.176 4.671H2.161L1.08 1.437zm2.58 5.24c.102.396.343.753.671 1.066a.47.47 0 00.113.107 4.045 4.045 0 001.364.75 6.005 6.005 0 001.929.312c.116 0 .227-.013.34-.02a.463.463 0 00.067.005c.023 0 .044-.009.067-.012 1.205-.087 2.23-.496 2.89-1.102a.46.46 0 00.1-.094c.297-.301.516-.64.613-1.011h3.364l-.471 8.265h-2.794c-.31-1.354-1.91-2.39-3.835-2.39-1.926 0-3.525 1.036-3.835 2.39H1.451l-.47-8.265h2.68z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { SmallSnacks }
